<!-- TrainingInstitutionDetail.vue -->
<template>
    <myDialog 
        :isDialog="dialogVisible" 
        :title="title" 
        :width="'1200px'"
        @handleClose="handleClose"
    >
        <template slot="content">
            <!-- 详情内容区域 -->
            <div class="detail-content" v-if="detailData">
                <!-- 基本信息 -->
                <div class="section-container">
                    <!-- <div class="section-header">基本信息</div> -->
                    <el-descriptions 
                        :column="2" 
                        border
                        size="medium"
                        class="detail-descriptions"
                    >
                        <el-descriptions-item label="班级编号">
                            {{ detailData.classId || '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="班级名称">
                            {{ detailData.className || '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="培训机构">
                            {{ detailData.institutionName || '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="培训项目">
                            {{ detailData.projectName || '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="培训等级">
                            {{ detailData.projectLevel || '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="补贴类型">
                            {{ detailData.subsidyTypeName || '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="开班日期">
                            {{ detailData.startDate || '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="结班日期">
                            {{ detailData.endDate || '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="联系人">
                            {{ detailData.contactPerson || '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="联系电话">
                            {{ detailData.contactPhone || '-' }}
                        </el-descriptions-item>
                        <el-descriptions-item label="所属区域">
                            {{ detailData.districtName || '-' }}
                        </el-descriptions-item>
                    </el-descriptions>
                </div>

            </div>
            
            <!-- 加载状态 -->
            <div v-else-if="loading" class="loading-container">
                <el-skeleton animated>
                    <template #template>
                        <el-skeleton-item variant="text" style="width: 30%" />
                        <el-skeleton-item variant="text" style="width: 40%; margin-left: 24px;" />
                        <el-skeleton-item variant="text" style="width: 35%" />
                    </template>
                </el-skeleton>
            </div>
            
            <!-- 无数据状态 -->
            <div v-else class="no-data">
                <el-empty description="暂无数据" />
            </div>
        </template>
        
        <!-- 底部按钮（可选） -->
        <template slot="footer">
            <div class="dialog-footer">
                <el-button @click="handleClose">关闭</el-button>
                <!-- 可以添加其他操作按钮 -->
                <!-- <el-button type="primary" @click="handleEdit">编辑</el-button> -->
            </div>
        </template>
    </myDialog>
</template>

<script>
import '@/assets/css/base.css'
import { getTrainingClassDetail } from '@/api/training'
export default {
name: 'classDetail',
props: {
    isDialog: {
        type: [String, Boolean],
        default: false
    },
    title: {
        type: String,
        default: ''
    },
    classId:{
        type: String,
        default:""
    }
},
data() {
    return {
        dialogVisible: false, // 控制弹窗显示
        detailData: {},     // 详情数据
        loading: false,       // 加载状态
    }
},
methods: {
    // 打开弹窗
    openDialog(row) {
        this.dialogVisible = true
        // 优先使用传入的 row 参数中的 classId，如果没有则使用 props
        const id = (row && row.classId) ? row.classId : this.classId
        if (id) {
            this.loadDetailData(id)
        } else {
            // 如果没有 id，等待 props 更新后再加载
            this.$nextTick(() => {
                if (this.classId) {
                    this.loadDetailData(this.classId)
                }
            })
        }
    },
    
    // 关闭弹窗
    handleClose() {
        this.dialogVisible = false
        this.detailData = null
        this.currentRowId = null
        // 可以通知父组件弹窗已关闭
        this.$emit('dialog-closed')
    },
    
    // 从接口加载详情数据（如果需要）
    async loadDetailData(classId) {
        if (!classId) {
            this.loading = false
            return
        }
        this.loading = true
        try {
            const res = await getTrainingClassDetail({ classId })
            if (res.code === 200) {
                this.detailData = res.data
            }
        } catch (error) {
            console.error('加载详情失败:', error)
        } finally {
            this.loading = false
        }
    },
    
    // 复制父组件的诚信等级图标方法
    getIntegrityGradeIcon(gradeName) {
        if (!gradeName) return ''
        const upperName = String(gradeName).toUpperCase()
        if (upperName.includes('A')) {
            return 'rankA'
        } else if (upperName.includes('B')) {
            return 'rankB'
        } else if (upperName.includes('C')) {
            return 'rankC'
        }
        return ''
    },
    
    // 获取图标路径
    getIntegrityGradeIconSrc(gradeName) {
        const iconName = this.getIntegrityGradeIcon(gradeName)
        if (!iconName) return ''
        return require(`@/assets/images/custom-icons/${iconName}.svg`)
    },
    
    // 格式化日期 (从 YYYYMMDD 格式转换为 YYYY-MM-DD)
    formatDate(dateStr) {
        if (!dateStr) return '-'
        // 如果是 YYYYMMDD 格式，转换为 YYYY-MM-DD
        if (dateStr.length === 8 && /^\d+$/.test(dateStr)) {
            return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`
        }
        return dateStr
    }
},
// 监听父组件传递的isDialog变化（如果使用props控制）
watch: {
    isDialog: {
        handler(newVal) {
            // 如果isDialog是Boolean类型
            if (typeof newVal === 'boolean') {
                this.dialogVisible = newVal
            }
            // 如果isDialog是String类型（例如："true-机构基本信息"）
            else if (typeof newVal === 'string') {
                this.dialogVisible = newVal.includes('true')
            }
        },
        immediate: true
    }
}
}
</script>


<style lang="scss" scoped>
.myDialog {
/deep/ .el-dialog__header {
    height: 48px;
    line-height: 48px;
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--vt-c-blue)!important;
}
        
/deep/ .el-dialog__title {
    color: #ffffff !important;
    font-weight: 700;
    font-size: 17px;
}
        
/deep/ .el-dialog__headerbtn {
    filter: brightness(0) invert(1) !important;
}
}

.detail-content {
padding: 20px;

.section-container {
    margin-bottom: 24px;
    
    &:last-child {
        margin-bottom: 0;
    }
    
    .section-header {
        display: flex;
        align-items: center;
        height: 40px;
        margin-bottom: 16px;
        
        &::before {
            content: '';
            width: 3px;
            height: 12px;
            background: var(--vt-c-blue-soft);
            margin-right: 8px;
        }
        
        &::after {
            content: '';
            flex: 1;
            height: 1px;
            border-top: 1px dashed #d3d4d6;
            margin-left: 8px;
        }
    }
    
    .detail-descriptions {
        /deep/ .el-descriptions__label {
            font-weight: 500;
            color: #606266;
            background: var(--vt-c-grey-mute);
        }
        
        /deep/ .el-descriptions__content {
            color: #303133;
        }
    }
    .basic-info-section {
        height: 200px;
        padding: 0 20px;
        border-radius: 4px;
        background: linear-gradient(180deg, rgba(230, 240, 254, 1) 0%, rgba(249, 251, 255, 1) 100%);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .basic-info-item {
            .basic-info-item-title {
                font-size: 24px;
                font-weight: 700;
                color: var(--vt-c-blue);
            }

            .basic-info-item-content {
                margin-top: 20px;
                display: flex;
                flex-direction: column;
                gap: 10px;
                .basic-info-item-content-item {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    justify-content: flex-start;
                    .basic-info-item-content-item-label {
                        font-size: 14px;
                        font-weight: 400;
                        color: #333333;
                    }
                    .basic-info-item-content-item-value {
                        font-size: 14px;
                        font-weight: 400;
                        text-align: center;
                        color: #333333;
                    }
                }
            }
        }
        .basic-info-icon {
            width: 545px;
            height: 100px;
            line-height: 100px;
            background: url('~@/assets/images/training/organization.png') no-repeat ;
            background-size: 100% 100%;
            text-align: center;
            color: var(--vt-c-white);
            font-size: 54px;
            font-weight: 400;
            div{
                margin-top: -8px;
            }
        }

    }
    .team-member-section {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 20px;
        flex-wrap: wrap;
        
        .team-member-card {
            width: 360px;
            min-height: 100px;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            padding: 20px;
            position: relative;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: space-evenly;

        }
        .card-day{
            background: url('~@/assets/images/training/dayRemainingBg.png') no-repeat;
            background-size: 100% 100%;
        }
        .card-student{
            background: url('~@/assets/images/training/peopleNumberBg.png') no-repeat;
            background-size: 100% 100%;
        }
    }
    
    .license-info-section {
        height: 180px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        
        .license-info-item {
            width: 360px;
            min-height: 100px;
            background: url('~@/assets/images/training/licensebg.png') no-repeat;
            background-size: 100% 100%;
            padding: 20px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            
            .license-info-content {
                display: flex;
                align-items: center;
                gap: 10px;
                z-index: 1;
                position: relative;
                width: 100%;
                
                .license-label {
                    font-size: 14px;
                    font-weight: 400;
                    color: #303133;
                    flex-shrink: 0;
                }
                
                .license-value {
                    font-size: 14px;
                    font-weight: 400;
                    color: #303133;
                }
            }
        }
    }
}
}

</style>
